// js
import React, { Component } from 'react';
import dsaView, { defaultPropTypes } from './dsaView';
import KeyGoalsList from '../components/goals/KeyGoalsList';
import Button from '../components/common/Button';
import KeyGoalsListNav from '../components/goals/KeyGoalsListNav';
import KeyGoalsCard from './goals/KeyGoalsCard';
import { SectionHeader } from '@its-svp/svp-common-ui';


class KeyGoals extends Component {

  canToggle(areas) {
    return areas.length > 1;
  }

  render() {
    const {
      baseNavRoute,
      abilities,
      areas,
      area,
      extensions,
      goals,
      dsa,
      params,
      activeAreaIds,
      updateDSAGoalAnswer,
      toggleBusinessArea
    } = this.props;

    // get goal questions for current area and sort by the 'order' attrib
    const questions = area && goals.filter(g => g.area === area.id).sort(g => g.order);
    const startButton = (
      <Button
        to={`${baseNavRoute}/goals/${activeAreaIds[0] || ''}`}
        primary
        disabled={activeAreaIds.length === 0}
        label='Start'
      />
    );

    return (
      <div className='key-goals'>
        <div className='container'>
          {!area &&
            <section className='content-wrapper'>
              <div className='svp-common-ui'>
                <SectionHeader
                  title='Key Goals'
                  description='Which of the following centers are relevant to the customer for this assessment?'
                  button={startButton}
                  landing
                />
              </div>
              <div className='area-cards key-goal-cards'>
                {areas.map(area => (
                  <KeyGoalsCard
                    key={area.id}
                    area={area}
                    dsa={dsa}
                    toggle={toggleBusinessArea}
                    canActivateArea={abilities.canActivateArea(area)}
                    canToggle={this.canToggle(activeAreaIds)}
                  />
                ))}
              </div>
            </section>
          }
          {!!area &&
            <section className='content-wrapper svp-common-ui'>
              <KeyGoalsListNav
                baseNavRoute={baseNavRoute}
                canEditUsage={abilities.canEditUsage}
                area={area}
                areas={areas}
                activeAreaIds={activeAreaIds}
                dsa={dsa}
                extensions={extensions}
                top
              />
              <SectionHeader
                title={`Key Goals: ${area.title}`}
                description={`${area && area.keygoalintro} This information will determine key value drivers and data sources to help you plan your Splunk deployment.`}
              />
              <div className='key-goals-panel'>
                <KeyGoalsList
                  baseNavRoute={baseNavRoute}
                  canEditUsage={abilities.canEditUsage}
                  routeParams={params}
                  questions={questions}
                  dsaGoals={dsa.dsaGoals}
                  activeAreaIds={activeAreaIds}
                  area={area}
                  dsa={dsa}
                  areas={areas}
                  extensions={extensions}
                  updateAnswer={updateDSAGoalAnswer}
                />
              </div>
              <KeyGoalsListNav
                baseNavRoute={baseNavRoute}
                canEditUsage={abilities.canEditUsage}
                area={area}
                areas={areas}
                activeAreaIds={activeAreaIds}
                dsa={dsa}
                extensions={extensions}
              />
            </section>
          }
        </div>
      </div>
    );
  }
}

KeyGoals.propTypes = {
  ...defaultPropTypes
};

export default dsaView(KeyGoals);



// WEBPACK FOOTER //
// ./src/containers/KeyGoals.js